import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from '@angular/router';
import { FarmService } from 'src/app/services/farm-service.service';
import { PhameeService } from 'src/app/services/phamee.service';
import { UtilService } from 'src/app/services/utils.service';
declare const $:any;

@Component({
  selector: 'smart-manage-farm-view',
  templateUrl: './manage-farm-view.component.html',
  styleUrls: ['./manage-farm-view.component.scss','../../platform-color/platform-color.css']
})
export class ManageFarmViewComponent implements OnInit {
  template: any = sessionStorage.getItem('template');
  AllPlot: any[] = [];
  polygons: any[] = [];
  zoom: number = 18;
  datenow: any;
  
  // initial center position for the map
  lat: number = 13.764913;
  lng: number = 100.538283;
  loadMap: boolean = false;
  loadPolygon: boolean = false;
  submitted: boolean = false;
  confirmDeleteBtn: boolean = false;

  id: string;
  name: string;
  systemRole: string;
  delete_id: string;
  delete_zone_id: string;
  totalPlot: number;

  farmDetail = null;

  deleteModal: string = '#deleteModal';
  successDelModal: string = '#successDelModal';
  warningModal: string = '#warningModal';
  successDelFarmModal: string = '#successDelFarmModal';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private UtilService: UtilService,
    private spinner: NgxSpinnerService,
    private location: Location,
    private farmService: FarmService,
    private phameeService: PhameeService,
    
    private cd: ChangeDetectorRef
  ) { 
    this.id = this.route.snapshot.paramMap.get("id");
    this.name = this.route.snapshot.paramMap.get("name");
    this.totalPlot = this.UtilService.totalplot;
  }

  ngOnInit() {
    this.systemRole = sessionStorage.getItem('system_role');
    this.spinner.show();

    this.getDatenow();
    this.getFarmByname(this.name);
    this.getPlots(this.id)
  }

  getDatenow() {
    const eventNow = new Date();
    const optionsNow = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    this.datenow = eventNow.toLocaleDateString('th-TH', optionsNow);
  }
  
  getPlots(farmId) {
  this.phameeService.getPlotDashboard(farmId)
    .subscribe(success => {
      if (success.code == 200) {
        this.AllPlot = success.data.plot;

        for (let i = 0; i < this.AllPlot.length; i++) {
          const element = this.AllPlot[i];
          Object.assign(element,{widget_sensor : []})

          if (element.thing.length > 0) {
            for (let j = 0; j < element.thing.length; j++) {
              const elementThing = element.thing[j];
              if (elementThing.sensor.length > 0) {
                elementThing.sensor.forEach(sensor => {
                  if(!['camera', 'video', 'image_capture'].includes(sensor.type)){

                    element.widget_sensor.push(sensor)
                  }
                });
              }
            }
          }
        }
        this.loadMap = true;
        this.spinner.hide();

        this.cd.detectChanges();
      }else{
        this.AllPlot = [];
        
        this.loadMap = true;
        this.spinner.hide();

        this.cd.detectChanges();
      }
    });
  }

  getFarmByname(name){
    if(name){
      this.farmService.getFarmByName(name).subscribe(success => {
        if (success.code == 200) {
          this.farmDetail = success.data[0];

          this.lat = this.farmDetail.coordinates['center'].lat;
          this.lng = this.farmDetail.coordinates['center'].lon;
          this.zoom = this.farmDetail.coordinates['center'].zoom_lv;

          this.cd.detectChanges();
        }
      });
    }
  }


  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`)
  }
  
  markerDragEnd(m: marker, $event: MouseEvent) {
    console.log('dragEnd', m, $event);
  }

  mapReady(map) {
    map.setOptions({
      zoomControl: "true",
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      draggable: true
    });

    for (let i = 0; i < this.AllPlot.length; i++) {
      let polygons = [];
      const element = this.AllPlot[i];
      if(element.coordinates.map_polygon.length > 0){
        for (let j = 0; j < element.coordinates.map_polygon.length; j++) {
          const elementPolygon = element.coordinates.map_polygon[j];

          polygons.push(
            new google.maps.LatLng(elementPolygon.lat, elementPolygon.lon),
          )
        }
      }
        
      this.polygons.push(
        { polygons: polygons, color: element.zone.color || 'red' }
      )
    }
    this.loadPolygon = true;
    this.cd.detectChanges();
  }

  setDelete() {
    $('#DeleteSch').modal('show');
  }

  async delFarm(){
    this.farmService.deleteFarm(this.id).subscribe(async res=>{
      if(res.code = 200){
        if(this.AllPlot.length > 0){
          for (let i = 0; i < this.AllPlot.length; i++) {
            this.farmService.deletePlot(this.AllPlot[i]._id).subscribe(plot=>{

              if(this.AllPlot[i].zone_id){
                this.farmService.deleteZone(this.AllPlot[i].zone_id).subscribe(zone=>{
                  if(this.AllPlot.length == i+1){
                    $(`#DeleteSch`).modal("hide");
              
                    $(`${this.successDelFarmModal}`).modal("show");
                  }
                });
              }
            })
          }
        }else{
          $(`#DeleteSch`).modal("hide");
        
          $(`${this.successDelFarmModal}`).modal("show");
        }
      }
    })
  }

  async getMenu(url = "current"){
    await this.phameeService.getPlotMenu(sessionStorage.getItem('ChildOrg'))
    .subscribe(response => {
      let arrMenu = [];
      if (response.code == 200) {
        arrMenu = response.data    
        sessionStorage.setItem("menufarm", JSON.stringify(arrMenu));
        if(url == "current"){
          window.location.reload();
        }else{
          this.router.navigate(["/manage-farm"]).then(() => {
            window.location.reload();
          });
        }
      }
    });
  }

  delete(plot){
    this.delete_id = plot.id;
    this.delete_zone_id = plot.zone_id;

    $(`${this.deleteModal}`).modal("show");
  }

  addPlot(){
    if(this.AllPlot.length >= this.totalPlot){
      $(`${this.warningModal}`).modal("show");
    }else{

      this.router.navigate([`/manage-farm/${this.id}/${this.name}/plot/createPlot`]);
    }
  }

  delPlot(){
    this.farmService.deletePlot(this.delete_id).subscribe(async res=>{
      this.farmService.deleteZone(this.delete_zone_id).subscribe(zone=>{
        $(`${this.deleteModal}`).modal("hide");

        $(`${this.successDelModal}`).modal("show");
      });
    })
  }

  openGooglemap(){
    let url =   "https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination="+this.farmDetail.coordinates.center.lat+ ","+this.farmDetail.coordinates.center.lon;
    window.open(url, '_blank');
  }

  back(): void {
    this.router.navigateByUrl("/manage-farm");
  }
}

interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable: boolean;
  icon?: string;
}

